import { useParams } from "react-router-dom";

import { LoadingState } from "~/common/components";
import { billingNoteGenerationStatusMessages } from "~/providers/constants/billingNoteGenerationStatus";
import { useGetPatientZoomMeetingBillingNote } from "~/providers/hooks";
import {
  isBillingNoteGenerationFailed,
  isBillingNoteGenerationPending,
} from "~/providers/utils";
import { SessionBillingNoteForm } from "./billingNote/SessionBillingNoteForm";
import { SubmittedSessionBillingNote } from "./billingNote/SubmittedSessionBillingNote";

export const SessionBillingNote = () => {
  const { patientId, sessionId } = useParams();

  const { data: billingNote, isLoading } = useGetPatientZoomMeetingBillingNote({
    patientId: patientId ?? "",
    sessionId: sessionId ?? "",
    enabled: Boolean(patientId && sessionId),
  });

  if (!patientId || !sessionId) {
    return null;
  }

  if (isLoading) {
    return <LoadingState className="h-screen-calculated" />;
  }

  if (!billingNote) {
    return (
      <div className="py-8 text-sm text-gray-500">
        Billing note is not yet available.
      </div>
    );
  }

  if (billingNote.completed_at) {
    return <SubmittedSessionBillingNote data={billingNote} />;
  }

  if (isBillingNoteGenerationPending(billingNote)) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 py-8">
        <LoadingState className="h-auto" />
        <p className="text-sm text-gray-500">
          {billingNoteGenerationStatusMessages.IN_PROGRESS}
        </p>
      </div>
    );
  }

  return (
    <SessionBillingNoteForm
      patientId={patientId}
      sessionId={sessionId}
      data={billingNote}
      generationFailed={isBillingNoteGenerationFailed(billingNote)}
    />
  );
};
